import { Injectable } from '@angular/core';
import { LoginResponse } from '../core/models';

const ORGANIZATION_FRONTEND_APPLICATION = 'organization_frontend';

type GenericSuccessResponse = {
  success: boolean;
};

@Injectable({ providedIn: 'root' })
export class LoginService {
  // Use explicit backend URL so frontend (served on a different port)
  // can reach the API. Override by setting `window.__env.API_BASE`.
  private readonly base =
    (typeof window !== 'undefined' && (window as any).__env?.API_BASE) || 'http://localhost:3001';

  async login(email: string, password: string, _remember = false): Promise<LoginResponse> {
    void _remember;
    const url = this.base.replace(/\/$/, '') + '/api/login';
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        password,
        application: ORGANIZATION_FRONTEND_APPLICATION,
      }),
    });

    if (!res.ok) {
      let msg = res.statusText || 'Login failed';
      try {
        const json = await res.json();
        if (json?.message) msg = json.message;
      } catch {
        // ignore
      }
      throw new Error(msg);
    }

    return (await res.json()) as LoginResponse;
  }

  async requestPasswordReset(email: string): Promise<GenericSuccessResponse> {
    const url = this.base.replace(/\/$/, '') + '/api/auth/forgot-password';
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        application: ORGANIZATION_FRONTEND_APPLICATION,
      }),
    });

    if (!res.ok) {
      throw new Error('No se pudo solicitar el restablecimiento de contraseña');
    }

    return (await res.json()) as GenericSuccessResponse;
  }

  async resetPassword(token: string, password: string): Promise<GenericSuccessResponse> {
    const url = this.base.replace(/\/$/, '') + '/api/auth/reset-password';
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token,
        password,
        application: ORGANIZATION_FRONTEND_APPLICATION,
      }),
    });

    if (!res.ok) {
      let msg = 'No se pudo restablecer la contraseña';
      try {
        const json = await res.json();
        if (json?.message) {
          msg = String(json.message);
        }
      } catch {
        // ignore
      }
      throw new Error(msg);
    }

    return (await res.json()) as GenericSuccessResponse;
  }
}
